module.exports = {
      id: "ac9a9c5944038ae91418d548455d8502electricity-230v.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#ac9a9c5944038ae91418d548455d8502electricity-230v.svg",
      toString: function () {
        return this.url;
      }
    }